module.exports = __webpack_public_path__ + "img/ind-zjzg.08c61d51.png";